import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { useDisponibilidadISP } from '../../../../../hooks/useDisponibilidadIsp';
import { BarChart } from '../../../../../components/Charts/BarChart';
import { useTranslation } from 'react-i18next';

export function NewGraphAvailabilityNode({
  globalStatePeriod,
  objetivoId,
  time,
  horarioId = 0, // Default value for horarioId
}) {
  const { data, isLoading, isError } = useDisponibilidadISP({
    objetivoId: objetivoId,
    fechaInicio: globalStatePeriod.startDate,
    fechaTermino: globalStatePeriod.endDate,
    time,
    horarioId,
  });
  const { t } = useTranslation()

  const processedData = React.useMemo(() => {
    let chartSerieUp = [];
    let chartSerieDown = [];
    let chartSerieNoMon = [];
    let chartCategory = [];

    if (!data || !data.length) {
      return {
        chartSerieUp: [],
        chartSerieDown: [],
        chartSerieNoMon: [],
        chartCategory: [],
      };
    }

    for (const item of data) {
      chartCategory.push(item.nodo_nombre);
      chartSerieUp.push(
        parseFloat(
          (
            item.porcentaje_uptime +
            item.porcentaje_eventos_cliente +
            item.porcentaje_marcados_atentus
          ).toFixed(2)
        )
      );
      chartSerieDown.push(parseFloat(item.porcentaje_downtime.toFixed(2)));
      chartSerieNoMon.push(
        parseFloat(item.porcentaje_no_monitoreos.toFixed(2))
      );
    }
    return {
      chartSerieUp,
      chartSerieDown,
      chartSerieNoMon,
      chartCategory,
    };
  }, [data]);

  if (!isLoading && !data && !isError) {
    return (
      <Alert severity="error">
        {t('new-graph-availability-node.no-data')}
      </Alert>
    );
  }

  if (!isLoading && isError) {
    return (
      <Alert severity="error">
        {t('new-graph-availability-node.error')}
      </Alert>
    );
  }

  const {
    chartSerieUp,
    chartSerieDown,
    chartSerieNoMon,
    chartCategory,
  } = processedData;

  return (
    <Box>
      <BarChart
        chartCategory={chartCategory}
        chartSerieUp={chartSerieUp}
        chartSerieDown={chartSerieDown}
        chartSerieNoMon={chartSerieNoMon}
        title={t('new-graph-availability-node.graph.title')}
        isLoading={isLoading}
      />
    </Box>
  );
}
